export default __webpack_public_path__ + "static/media/noa-31.a597e31b.jpg";